<template>
  <div class="home">
    <header-div class="header-box"></header-div>
    <div class="content-box">
      <div class="bg-white">
        <h3 class="uset-tit">帮助中心 <span @click="toIndex">返回知识库</span></h3>
        <div class="user-info-box">
          <ul class="help-list">
            <li v-for="(item,index) in list" :key="item.id" :class="item.id === chioseid?'active':''"
                @click="showDetail(index)">
              {{ item.title }}
            </li>
          </ul>
          <div class="help-detail" v-html="content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import headerDiv from './components/header'

export default {
  name: 'user',
  data() {
    return {
      chioseid: '',
      content: '',
      list: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.$api.apiContent.GetHelpinfo({
        kind: 1
      }).then(res => {
        this.list = res.data
        //  获取信息
        this.chioseid = this.list[0].id
        this.content = this.list[0].content
      })
    },
    showDetail(index) {
      this.chioseid = this.list[index].id
      this.content = this.list[index].content
    },
    toIndex() {
      this.$router.push('/home/repositories')
    }
  },
  components: {
    headerDiv
  }
}
</script>


<style scoped lang="scss">
.content-box {
  width: 1200px;
  margin: 20px auto;
  padding: 20px;
  background: #0a2240;
  box-shadow: 10px 10px 10px #f3f3f3;
  border-radius: 8px;
  .bg-white {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    .uset-tit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #ddd;
      font-size: 20px;
      margin-bottom: 20px;

      span {
        display: block;
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: #0a2240;
        color: #fff;
        border-radius: 6px;
        font-size: 16px;
        cursor: pointer;
      }
    }

    .user-info-box {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 20px 0;

      .help-list {
        border-right: 1px solid #ddd;

        li {
          width: 300px;
          line-height: 24px;
          padding: 10px;
          font-size: 14px;
          cursor: pointer;

          &:hover {
            color: #0a2240;
          }
        }

        li.active {
          background: #0a2240;
          color: #fff;
          border-radius: 8px;
        }
      }

      .help-detail {
        flex: 1;
        padding: 10px 20px;
        line-height: 30px;
      }
    }
  }


}
</style>